module.exports = __webpack_public_path__ + "static/media/sofa-4.f3676822.webp";